import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SwicthStyle = styled.div`
  /* Parent
  ------------------------------- */
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;

  /* Childrens
  ------------------------------- */
  .react-switch-handle {
    border: 2px solid transparent !important;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media only screen and (max-width: 768px) {
  }
`
